"use client";
import {useNeoContext} from "@/context/neo/neo.context";
import Image from "next/image";
import Link from "next/link";
import {useState} from "react";

export const Settings: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const {filterContext} = useNeoContext();
  return (
    <>
      <div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-3">
        <Link
          href={`deviationsettings`}
          className="flex items-center"
          title="Deviation Settings"
        >
          <div className="flex h-full flex-col rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
            <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-[#FFC7271A]">
              <Image
                src="/icons/Deviation_Settings.svg"
                alt="Deviation Settings"
                width={25}
                height={25}
              />
            </div>
            <div className="mb-3">
              <h3 className="mb-2 text-lg font-semibold text-gray-900">
                Deviation Settings
              </h3>
              <p className="text-sm text-gray-500">
                Configure speed and distance deviation limits for fleet
                monitoring
              </p>
            </div>
            <div className="mt-auto flex items-center gap-1 text-xs text-gray-500">
              <Image
                src="/images/setting_deviation.svg"
                alt="Deviation Settings"
                width={16}
                height={16}
                className="mr-2"
              />
              <span>2 limits</span>
            </div>
          </div>
        </Link>
        {/*<div className="rounded-xl border border-gray-200 bg-white shadow-sm p-5 flex flex-col h-full">
          <div className="mb-2">
            <img src="/images/setting_deviation_yellow.svg" alt="Vehicle Ordering" className="h-10 w-10" />
          </div>
          <div className="mb-3">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Vehicle Ordering</h3>
            <p className="text-sm text-gray-500">
              Manage vehicle display order and priority settings
            </p>
          </div>
          <div className="flex items-center gap-1 text-xs text-gray-500 mt-auto">
            <img src="/images/setting_vehicle.svg" alt="Vehicle Ordering" className="h-5 w-5" />
            <span>4 vehicles</span>
          </div>
        </div>*/}
        <Link
          href={`fleet`}
          className="flex items-center"
          title="Expense Settings"
        >
          <div className="flex h-full flex-col rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
            <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-[#FFC7271A]">
              <Image
                src="/icons/setting_cash.svg"
                alt="Deviation Settings"
                width={32}
                height={32}
              />
            </div>
            <div className="mb-3">
              <h3 className="mb-2 text-lg font-semibold text-gray-900">
                Expense Settings
              </h3>
              <p className="text-sm text-gray-500">
                Configure vendor list, approved fuel stations, expense
                categories
              </p>
            </div>
            <div className="mt-auto flex items-center gap-1 text-xs text-gray-500">
              <Image
                src="/images/setting_expense.svg"
                alt="Vehicle Ordering"
                width={16}
                height={16}
                className="mr-2"
              />
              <span>4 master data</span>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};
